import type { MainProps } from "@site-types/components/main"

export function Main({ children }: MainProps) {
  return (
    <main className="relative z-[3] ml-[var(--side-menu-width)] flow-root min-h-[100dvh] w-[calc(100%-var(--side-menu-width))] overflow-x-clip">
      {children}
    </main>
  )
}

export default Main
